import { debounce } from "@ui-lib/index"
import { Dispatch, SetStateAction, useState } from "react"
import { useTranslation } from "react-i18next"
import { MdClear, MdSearch } from "react-icons/md"

export function GlobalFilter({
	globalFilter,
	setGlobalFilter,
	translationFunc,
}: {
	globalFilter: string
	setGlobalFilter: Dispatch<SetStateAction<string>>
	translationFunc: ReturnType<typeof useTranslation>["t"]
}) {
	const [value, setValue] = useState(globalFilter)
	const onChange = debounce((value: string) => {
		setGlobalFilter(value ?? undefined)
	}, 200)

	return (
		<div className="flex justify-end">
			<div className="relative inline-block">
				<div className="absolute inset-x-1.5 inset-y-1.5 h-5 w-5">
					<MdSearch className="text-dipai-secondary-800 h-5 w-5" />
				</div>

				<input
					id="fleet-search-input"
					className="border-dipai-text-muted text-menu hover:border-dipai-text-highlight focus:border-dipai-text-highlight text-dipai-text-primary h-8 w-70 rounded-sm border-1 pr-8 pl-8 focus:border-2 focus:pl-[calc(2rem-0.0625rem)] focus:outline-hidden"
					value={value ?? ""}
					onChange={(e) => {
						setValue(e.target.value)
						onChange(e.target.value)
					}}
					placeholder={`${translationFunc("SEARCH ALL RECORDS")}`}
				/>

				{value !== "" && value !== undefined && (
					<div
						className="absolute inset-y-1.5 right-1.5 h-5 w-5 cursor-pointer"
						onClick={() => {
							setValue("")
							onChange("")
						}}
					>
						<MdClear className="text-dipai-text-secondary h-5 w-5" />
					</div>
				)}
			</div>
		</div>
	)
}
